import React from "react";
import DynamicForm from "modules/dynamicForm";

const Main = () => {
  return <DynamicForm />;
};

export default Main;
